function InitializeNielsenRegion() {
    $('#nielsen-region-container input:checkbox:last').parent().addClass('nielsen-select-all');
    $('#nielsen-region-container input:checkbox:last').click(function () {
        if ($(this).is(':checked')) {
            $('#nielsen-region-container input:checkbox').prop('checked', true);
        } else {
            $('#nielsen-region-container input:checkbox').prop('checked', false);
        }
    });

    $('#nielsen-region-container input:checkbox:not(:last)').click(function() {
        var nielsenSelections = $('#nielsen-region-container input:checkbox:not(:last)');
        var selected = $('#nielsen-region-container input:checkbox:not(:last):checked');
        if (nielsenSelections.length != selected.length) {
            $('#nielsen-region-container input:checkbox:last').prop('checked', false);
        } else {
            $('#nielsen-region-container input:checkbox:last').prop('checked', true);
        }
    });
}



